import { load } from '../lib/_load.js';
import { loc } from '../lib/_location.js';
export class Office{
	constructor(){
		this.searchInput 		= document.querySelectorAll("input#search");
		this.searchButton 		= document.querySelectorAll("button#start_search");
		this.areaSelector 		= document.querySelectorAll("#area select");
		this.categorySelector	= document.querySelectorAll("#business select");
		this.resultContainer = document.querySelector("#results .c-list_office ul");
		this.clearBtn = document.querySelectorAll("button[data-clear-filter]");
		this.clearTxtBtn = document.querySelectorAll("button[data-clear-search]");
		this.businessFilterText = document.querySelector("#business .c-selected_text p");
		this.areaFilterText = document.querySelector("#area .c-selected_text p");
		this.data = [];
		this.filtered = [];
		this.location = loc.all();

		this.changeURL = this.changeURL.bind(this);
		this.searchFromURL = this.searchFromURL.bind(this);

		let url = "/assets/json/offices.json";
		load.getJson( url ).then( (res) => {
			this.data = res;
			this.filtered = res;
			this.searchFromURL();
			this.nav();
			//console.log(this.location);
			//console.log(this.data);
		});
	}
	nav(){
		const eventListenersMultiple = [
			{ elements: this.searchInput, type: "change", handler: this.changeURL.bind(this) },
			{ elements: this.searchInput, type: "input", handler: this.checkVal },
			{ elements: this.areaSelector, type: "change", handler: this.changeURL.bind(this) },
			{ elements: this.categorySelector, type: "change", handler: this.changeURL.bind(this) },
			{ elements: this.clearBtn, type: "click", handler: (e) => { e.preventDefault(); this.clearFilter(); this.changeURL(); } },
			{ elements: this.clearTxtBtn, type: "click", handler: (e) => { e.preventDefault(); this.clearText(); this.changeURL(); } }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
		window.addEventListener("popstate", this.searchFromURL);
	}
	clearFilter(e) {
		e?.preventDefault();
		//const inputEl    = document.querySelector("input#search");
		const areaEl     = document.querySelector("#area select");
		const categoryEl = document.querySelector("#business select");
		//if (inputEl)    inputEl.value = "";
		if (areaEl)     areaEl.value = "";
		if (categoryEl) categoryEl.value = "";
	}
	clearText(e){
		e?.preventDefault();
		const inputEl    = document.querySelector("input#search");
		if (inputEl)    inputEl.value = "";
	}
	changeURL(e){
		let $this = this;
		
		const trigger = e?.target;
		if (trigger) {
			if (trigger.id === "search") {
				$this.clearFilter();
			} else if (trigger.closest("#area")) {
				$this.clearText();
			} else if (trigger.closest("#business")) {
				$this.clearText();
			}
		}
		
		const text     = document.querySelector("input#search")?.value.trim() || "";
		const area     = document.querySelector("#area select")?.value || "";
		const category = document.querySelector("#business select")?.value || "";
		
		
		
		const params = new URLSearchParams();
		if (text)     params.set("text", text);
		if (area)     params.set("area", area);
		if (category) params.set("category", category);

		const qs = params.toString();
		const newURL = qs ? `${location.pathname}?${qs}` : location.pathname;

		// URLを書き換え（ページ遷移なし）
		history.pushState(null, "", newURL);

		// URLに基づいて検索実行
		this.searchFromURL();
	}
	searchFromURL() {
		const params   = new URLSearchParams(window.location.search);
		const text     = params.get("text")?.trim().toLowerCase() || "";
		const area     = params.get("area") || "";
		const category = params.get("category") || "";

		// フォームの値をURLと同期（ブラウザバック時に必要）
		const inputEl    = document.querySelector("input#search");
		const areaEl     = document.querySelector("#area select");
		const categoryEl = document.querySelector("#business select");
		if (inputEl)    inputEl.value = params.get("text") || "";
		if (areaEl)     areaEl.value = area;
		if (categoryEl) categoryEl.value = category;
		this.setText();
		// フィルタリング
		this.filtered = this.data.filter((office) => {
			// テキスト検索（スペース区切りAND）
			if (text) {
				const target = [
					office.name || "",
					office.base_name || "",
					office.address || "",
					office.for_search || "",
				].join(" ").toLowerCase();
				const keywords = text.split(/\s+/);
				if (!keywords.every((kw) => target.includes(kw))) return false;
			}

			// エリア検索
			if (area) {
				if (office.area_category?.id !== area) return false;
			}

			// カテゴリ検索
			if (category) {
				const ids = Array.isArray(office.to_b_category)
					? office.to_b_category.map((c) => c.id)
					: [];
				if (!ids.includes(category)) return false;
			}

			return true;
		});
		this.checkVal();
		this.renderList();
	}
	renderList(){
		if (!this.resultContainer) return;

		if (this.filtered.length === 0) {
			this.resultContainer.innerHTML = `<p>該当する事業所が見つかりませんでした。</p>`;
			return;
		}
		
		let getCat = ( office ) =>{
			let cats = "";
			office.to_b_category.forEach( (c)=> {
				//console.log(c);
				cats += `<span>${c.name}</span>`;
			});
			return cats;
		}
		
		let HTML = "";
		
		this.filtered.forEach((office) => {
			//console.log(office)
			let img = office.image;
			let imgHTML = "";
			if( img ){
				imgHTML = `<figure>
								<img src="${office.image.url}" alt="${office.name}" width="156" height="104">
							</figure>`
			}else{
				imgHTML = `<figure>
								<img src="https://images.microcms-assets.io/assets/720bb66a2e0d4fccb99c3e1a4b342790/5fc3f870f9a24e8686be1e1446f9eac2/blank_about-locations.jpg?f=webp&w=312" alt="${office.name}" width="156" height="104">
							</figure>`
			}
			let webLink = "";
			if( office.link ) {
				webLink = `<p class="avenir link">
								<a href="${office.link}" target="_blank">${office.link}</a>
							</p>`
			}
			HTML += `
				<li class="office-item" data-area="" data-category="">
					<div class="c-cols">
						<div class="cols_l">
							<div class="c-name">
								<p>${office.name}</p>
								<h3>${office.base_name}</h3>
							</div>
							<div class="c-location">
								<p class="avenir">〒${office.zipcode ? office.zipcode.replace(/(\d{3})(\d{4})/, "$1-$2") : ""}</p>
								<p class="address">${office.address}</p>
								<p class="avenir">${office.tel}</p>
								${webLink}
							</div>
							<div class="c-business_department">
								<p>${getCat(office)}</p>
							</div>
						</div>
						<div class="cols_r">
							${imgHTML}
						</div>
					</div>
				</li>
			`;
		});
		document.querySelector("#result_num").innerHTML = this.filtered.length;
		this.resultContainer.innerHTML = HTML;
		
	}
	checkVal(){
		let $this = this;
		const text     = document.querySelector("input#search")?.value.trim() || "";
		let $searchBox = document.querySelector(".c-search");
		
		if( text.length > 0 ){
			if( !$searchBox.classList.contains("has-text") ){
				$searchBox.classList.add("has-text");
			}
		}else{
			if( $searchBox.classList.contains("has-text") ){
				$searchBox.classList.remove("has-text");
			}
		}
	}
	setText(  ){
		let $this = this;
		let select = document.querySelector("#business select")
		let txt = select.options[select.selectedIndex].text;
		$this.businessFilterText.innerHTML = txt;
		
		let selectArea 	= document.querySelector("#area select")
		let areaTxt 	= selectArea.options[selectArea.selectedIndex].text;
		//console.log(areaTxt);
		$this.areaFilterText.innerHTML = areaTxt;
	}
}

export let offices = {
	search: null,
	init: function(){
		let $search = document.querySelector("input#search");
		if( $search ){
			offices.search = new Office();
		}
	}
}
